import React, { useEffect, useState } from 'react'
import Slider from "react-slick";
import ProductCard from '../ProductCard';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase';
import Css from './EventSection.module.scss';
import { makeApiCall } from '../../utils/makeApiCall';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


const EventSection = () => {

  const [fairs, setFairs] = useState([]);
  const [loading, setLoading] = useState(false);


  const settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "60px",
    slidesToShow: 3,
    slidesToScroll: 2,
    autoplay: true,
    speed: 2000,
    lazyLoad: true,
  };


  const fetchData = async () => {
    setLoading(true)
    // const data = await getDocs(clientsCollectionsRef);
    // const res = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }))

    try {
      const res = await makeApiCall({
        method: "GET",
        path: "/fairs",
        payload: {
          "intUid": 0
        },
      })
      setFairs(res.data)
      setLoading(false)
    } catch (err) {
      console.error(err);
      setLoading(false)
    }
  }


  useEffect(() => {
    fetchData()
  }, [])


  return (
    <div className={Css.event_card}>
      <div>
        <Slider {...settings}>
          {fairs.length > 0 && fairs.map(fair =>
            <ProductCard client={fair} key={fair._id} />
          )}
        </Slider>
      </div>
    </div>
  )
}

export default EventSection;
